module.exports = __webpack_public_path__ + "static/media/iphone12_fv-02.b114eaa1.png";